import type { FC, PropsWithChildren } from 'react';
import type { UseFormReturn } from 'react-hook-form';
import { FormProvider } from 'react-hook-form';

import type { PostFormValues } from '@/features/post-editor/types/postForm';

type Props = PropsWithChildren<{
  form: UseFormReturn<PostFormValues>;
}>;

export const PostFormProvider: FC<Props> = ({ form, children }) => (
  <FormProvider {...form}>{children}</FormProvider>
);
